module.exports = __webpack_public_path__ + "static/media/sort-desc.514b0d00.svg";